import { createContext, useContext } from 'react';

export const TagContext = createContext();

export const useTagContext = () => useContext(TagContext);
